import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type WholesaleProductFragment = { id: string, created: any, name: string, slug: string, sortOrder: number, description: any, rectangularImage: string | null, squareImage: string | null };

export const WholesaleProductFragmentDoc = gql`
    fragment WholesaleProductFragment on WholesaleProductType {
  id
  created
  name
  slug
  sortOrder
  description
  rectangularImage(method: THUMBNAIL_WEBP, size: "1600x0")
  squareImage(method: THUMBNAIL_WEBP, size: "600x0")
}
    `;